type AmendmentListParams = {
  companyId: string
  budgetingScenarioId?: number | null
}

type AmendmentDetailParams = {
  companyId: string
  amendmentId?: number
  budgetingScenarioId?: number | null
}

type AmendmentReportParams = {
  accountCode: number
  budgetingScenarioId?: number | null
}

export const amendmentKeys = {
  all: [{ scope: 'amendment' }] as const,
  lists: () => [{ ...amendmentKeys.all[0], entity: 'list' }] as const,
  list: (params: AmendmentListParams) => [{ ...amendmentKeys.lists()[0], ...params }] as const,
  details: () => [{ ...amendmentKeys.all[0], entity: 'detail' }] as const,
  detail: (params: AmendmentDetailParams) => [{ ...amendmentKeys.details()[0], ...params }] as const,
  reports: () => [{ ...amendmentKeys.all[0], entity: 'report' }] as const,
  report: (params: AmendmentReportParams) => [{ ...amendmentKeys.reports()[0], ...params }] as const,
  counterReports: () => [{ ...amendmentKeys.all[0], entity: 'counter-report' }] as const,
  counterReport: (params: AmendmentReportParams) => [{ ...amendmentKeys.counterReports()[0], ...params }] as const
}
